import { createSlice } from '@reduxjs/toolkit';
import { STRATEGY_UPDATE } from '../../shared/AppConstants';

const initialState = {
  activeTab: STRATEGY_UPDATE,
  selectedPhases: [],
  templateToAdd: null
};

const adminSlice = createSlice({
  name: 'adminSlice',
  initialState,
  reducers: {
    updateActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setTemplateToAdd: (state, action) => {
      state.templateToAdd = action.payload;
    }
  }
});

export const { updateActiveTab, setTemplateToAdd } = adminSlice.actions;

export const adminReducer = adminSlice.reducer;
